import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'host-priority-rule',
  templateUrl: './priority-rule.component.html',
  styleUrls: ['./priority-rule.component.scss']
})
export class PriorityRuleComponent implements OnInit {

  constructor(private modalRef: NzModalRef) { }

  ngOnInit() {
  }

  onClose() {
    this.modalRef.destroy();
  }
}
